module.exports = function getResource(label, vars = []) {
    let resources = {
        status: 'Status',
        seeTrackingDetails: 'See tracking details',
        shippingMethod: 'Shipping Method',
        estimatedDelivery: 'Estimated Delivery',
        tracking: 'Tracking #',
        shipTo: 'Ship To',
        billingInfo: 'Billing Info',
        paypalAccount: 'Paypal Account',
        applePay: 'Apple Pay',
        shipment: 'SHIPMENT',
        needToReturnSomething: 'Need to return something?',
        changedYourMind: 'Changed your mind?',
        cancelYourOrder: 'Cancel your order',
        paidWith: 'Paid with '
    };

    return resources[label];
};
